class AppUrl {
	//static baseurl = "https://api.binccoin.com/"
    static baseurl = 'http://127.0.0.1:8000/'
    static wsurl = 'ws://localhost:8000/'
    static photoUrl = this.baseurl+'static/images/';

}

export default AppUrl